import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'

import { ReservationCalendars } from '../ReservationCalendars'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'
import { ReservationsList } from '../../components/ReservationsList'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'
import { useAPIGetReservationRulesAndTerms } from '../../api/apiHooks/useAPIGetReservationRulesAndTerms'

import {
  SidebarInfoSection,
  SidebarInfoSectionLink,
  SidebarInfoSectionText,
  View,
} from 'components'

export const GymReservations: React.FC = () => {
  const { t, i18n } = useTranslation(['common', 'reservations', 'titles'])
  const moduleConfig = useModuleConfig()
  const { frontPagePath } = useContractPaths()
  const { currentContractId } = useCurrentContract()

  const { data: rulesAndTerms } = useAPIGetReservationRulesAndTerms(
    currentContractId,
    'gym',
    i18n.language,
    null
  )

  const moduleLinks: { href: string; label: string }[] = []
  const gymReservationsConfig = moduleConfig.gymReservations
  if (gymReservationsConfig?.contractDocumentLink) {
    moduleLinks.push({
      href: gymReservationsConfig.contractDocumentLink,
      label: t('reservations:modal.commonAreaRulesLink'),
    })
  }
  if (gymReservationsConfig?.termsOfUseDocumentLink) {
    moduleLinks.push({
      href: gymReservationsConfig.termsOfUseDocumentLink,
      label: t('reservations:modal.commonAreaTermsLink'),
    })
  }

  const dbLinksAll = rulesAndTerms
    ? [
        ...rulesAndTerms.files.map((file) => ({
          href: file.url,
          label: file.displayFileName,
        })),
        ...rulesAndTerms.externalLinks.map((link) => ({
          href: link.url,
          label: link.title,
        })),
      ]
    : []

  const infoLinks = dbLinksAll.length > 0 ? dbLinksAll : moduleLinks

  return (
    <TitleController title={t('titles:gymReservations', 'Gym reservations')}>
      <View allowOverflow>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>
          <View.HeaderTitle className="phone:text-common-gray-7">
            {t('reservations:pageTitleGym')}
          </View.HeaderTitle>
        </View.Header>

        <View.Sidebar>
          <SidebarInfoSection className="space-y-4">
            <SidebarInfoSectionText>
              {t(
                'reservations:gymSidebarDescription',
                'Täällä voit tarkastella kuntosalivuoroja ja varata oman vuoron valitsemalla vapaan ajan'
              )}
            </SidebarInfoSectionText>
            {infoLinks.length > 0 && (
              <div className="space-y-3">
                {infoLinks.map((link) => (
                  <SidebarInfoSectionLink
                    key={link.href}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm leading-4"
                  >
                    {link.label}
                  </SidebarInfoSectionLink>
                ))}
              </div>
            )}
          </SidebarInfoSection>
          <ReservationsList reservableCategory="gym" />
        </View.Sidebar>

        <View.Content>
          <ReservationCalendars reservableCategory="gym" />
        </View.Content>
      </View>
    </TitleController>
  )
}
